import { useEffect, useState } from 'react'

export function useImageIsLoaded(
  src: string | null,
  isImageValid?: (img: HTMLImageElement) => boolean | Promise<boolean>
) {
  const [{ isLoaded, isError }, setState] = useState({
    isLoaded: false,
    isError: false,
  })

  useEffect(() => {
    if (src) {
      const img = new Image()
      img.onload = async () => {
        const valid = isImageValid ? await isImageValid(img) : true
        if (valid) {
          setState({ isLoaded: true, isError: false })
        } else {
          setState({ isLoaded: false, isError: true })
        }
      }
      img.onerror = () => {
        setState({ isLoaded: false, isError: true })
      }
      img.src = src
    }
  }, [src, isImageValid])

  return { isLoaded, isError }
}
